import { NbJSThemeOptions } from '@nebular/theme';
import { DEFAULT_THEME } from './theme.default';

export const UTUM_SUS_THEME = {
  name: 'utum-sus_default',
  base: 'default',
  // We could override this in the future
  variables: DEFAULT_THEME.variables,
} as NbJSThemeOptions;
